import React from "react";
import styled from "styled-components";
import { ErrorKeyValue, ErrorKeyValueMap } from "@constant/ErrorKeyValue";
import { Space, Typography } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";
import Link from "antd/lib/typography/Link";

const ErrorContentWrapper = styled.section<{ height?: string }>`
  height: ${({ height }) => height || "200px"};
  overflow: auto;
`;
const ErrorContent = styled(Typography.Text)`
  margin-left: 10px;
`;

type ErrorItem = {
  idx: number;
  field: string;
  desc: string;
  url?: string;
  sku?: string | string[];
};
export type ImportErrorResult = Record<string, ErrorItem[]>;
/* importErrorResult example
 const result = {
   "600": [
     {
       idx: 5,
       field: "sku, qty",
       desc: "欄位不得為空",
     },
   ],
   "702": [
     {
       idx: 7,
       field: "sku",
       desc: "商品不存在",
     },
   ],
 };
*/

type Props = {
  errorResult: ImportErrorResult;
  height?: string;
};
const ErrorResultsList = (props: Props) => {
  const { errorResult, height } = props;
  return (
    <ErrorContentWrapper height={height}>
      {Object.keys(errorResult).map((keyString) => {
        const errorItems = errorResult[Number(keyString)];
        const key = Number(keyString);
        switch (key) {
          case ErrorKeyValue.NOT_EXIST_VPC:
            return (
              <Paragraph>
                <Title level={5}>商品尚未建立通路為【品運】的合作方式：</Title>
                <Space>
                  {errorItems.map((item) => {
                    return (
                      <Link key={item.idx} href={`${item.url}`} target="_blank" rel="noreferrer">
                        {item.sku}
                      </Link>
                    );
                  })}
                </Space>
              </Paragraph>
            );

          default:
            return (
              <Paragraph>
                <Title level={5}>{ErrorKeyValueMap[key]}</Title>
                {errorItems.map((item) => {
                  return (
                    <div key={item.idx}>
                      列{item.idx}
                      <ErrorContent mark>{item.field}</ErrorContent> : {item.desc && `${item.desc} ,`}
                      {item.sku && typeof item.sku === "object"
                        ? item.sku.map((sku) => {
                            return (
                              <span key={sku} style={{ marginRight: "5px" }}>
                                {sku}
                              </span>
                            );
                          })
                        : item.sku}
                    </div>
                  );
                })}
              </Paragraph>
            );
        }
      })}
    </ErrorContentWrapper>
  );
};

export default ErrorResultsList;
